<template>
  <v-container fluid>
    <v-card class="elevation-1 mb-6">
      <v-card-title class="pa-7">
        Přehled uživatelů
        <v-spacer class="mb-10"></v-spacer>
      </v-card-title>
      <v-card-text>
        <UsersFilters @filter="setFiltersAction" />

        <v-data-table
          :headers="userHeadersByRole"
          :items="user.items"
          :options.sync="user.options"
          :server-items-length="user.serverItemsLength"
          :loading="user.loading"
          item-key="id"
          class="elevation-0"
        >
          <template v-slot:item.customer.id="{ item }">
            <router-link
              v-if="item.customer"
              :to="{
                name: 'customers.detail',
                params: {
                  customerId: item.customer.id,
                },
              }"
            >
              {{ item.customer.id }}
            </router-link>
          </template>
          <template v-slot:item.id="{ item }">
            <router-link
              v-if="item.customer"
              :to="{
                name: 'customers.detail',
                params: {
                  customerId: item.customer.id,
                },
              }"
            >
              {{ item.id }}
            </router-link>
            <span v-else>
              {{ item.id }}
            </span>
          </template>
          <template v-slot:item.createdAt="{ item }">
            <DateTime :datetime="item.createdAt" :single-line="false" />
          </template>
          <template v-slot:item.role="{ item }">
            <UserRole :role="item.role" />
          </template>
          <template v-slot:item.status="{ item }">
            <UserStatus :status="item.status" />
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import UsersFilters from '@/components/filters/UsersFilters.vue'
import { setFilters } from '@/components/mixins/setFilters'
import DateTime from '@/components/DateTime'
import UserRole from '@/components/customer/UserRole'
import UserStatus from '@/components/customer/UserStatus'

export default {
  name: 'Users',
  components: {
    UserStatus,
    UserRole,
    DateTime,
    UsersFilters,
  },
  mixins: [setFilters],
  data() {
    return {
      user: {
        headers: [
          {
            text: 'Datum',
            value: 'createdAt',
            roles: ['ROLE_ADMIN'],
            width: '150px',
          },
          {
            text: 'Id',
            value: 'id',
            roles: ['ROLE_ADMIN'],
            width: '100px',
          },
          {
            text: 'E-mail',
            value: 'email',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: 'Id zákazníka',
            value: 'customer.id',
            roles: ['ROLE_ADMIN'],
            sortable: false,
          },
          {
            text: 'Jméno zákazníka',
            value: 'customer.fullName',
            roles: ['ROLE_ADMIN'],
            sortable: false,
          },
          {
            text: 'Role',
            value: 'role',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: 'Stav',
            value: 'status',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: '',
            value: 'actions',
            width: '1px',
            sortable: false,
            roles: ['ROLE_ADMIN'],
          },
        ],
        items: [],
        options: {
          page: 1,
          itemsPerPage: 10,
          sortBy: ['id'],
          sortDesc: [false],
        },
        loading: false,
        serverItemsLength: 0,
      },
      userFooter: {
        totalElements: 0,
        selectedData: {
          params: {},
          items: [],
        },
      },
      cancel: null,
    }
  },
  computed: {
    ...mapState({
      authorities: (state) => state.auth.user.authorities,
    }),
    userHeadersByRole() {
      return this.user.headers.filter((e) => e.roles.some((e) => this.authorities.includes(e)))
    },
  },
  watch: {
    'user.options': {
      handler() {
        this.loadUsers()
      },
    },
    '$route.query': {
      handler() {
        this.loadUsers()
      },
    },
  },
  methods: {
    ...mapActions({
      searchUsers: 'user/searchUsers',
    }),
    loadUsers() {
      this.user.loading = true
      const searchParams = {
        filterParams: this.$route.query,
        options: this.user.options,
      }
      this.searchUsers({ params: searchParams, roles: ['CUSTOMER', 'CUSTOMER_UNCONFIRMED'] })
        .then((response) => {
          this.userFooter.totalElements = response.data.totalElements
          this.user.items = response.data.items
          this.user.serverItemsLength = response.data.totalElements
          this.cancel = null
        })
        .finally(() => {
          this.user.loading = false
        })
    },
    setFiltersAction(filters) {
      this.user.options.page = 1
      this.setFilters(filters)
    },
  },
}
</script>
